import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Plan } from "@/types"
import { fetchActivePlans } from "./plansThunks"

interface PlansState {
  plans: Plan[]
  loading: boolean
  loaded: boolean
  error: string | null
}

const initialState: PlansState = {
  plans: [],
  loading: false,
  loaded: false,
  error: null,
}

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivePlans.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchActivePlans.fulfilled, (state, action: PayloadAction<Plan[]>) => {
        state.loading = false
        state.loaded = true
        state.plans = action.payload
      })
      .addCase(fetchActivePlans.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "Failed to fetch plans"
      })
  },
})

export default plansSlice.reducer
